<template>
  <loader v-if="loading"></loader>
  <find-page-layout
    v-else
    :breadcrumbs="breadcrumbs"
    :filters="filters"
    :page-request="pageRequest"
    :sorters="sorters"
    :page="page"

    filters-title="Ricerca analisi"
    results-title="Analisi"
    no-results-message="Nessuna analisi trovata"

    @selectPageSize="selectPageSize"
    @find="find"
    @sort="sortBy"
    @selectPage="selectPage">
    <b-card slot="filters">
      <analysis-filters v-model="filters" />
    </b-card>
    <b-row slot="results">
      <b-col v-for="r in page.content" md="4">
        <router-link-card
          :disabled="!r.permissions.load"
          :to="{ name: 'Analysis', params: { id: r.id } }">
          <div slot="header" class="font-weight-bold">
            {{ r.title }}
          </div>
          <div>
            <info-field labelClass="col" label="Proprietario">
              {{ r.owner.displayName }}
            </info-field>
            <info-field labelClass="col" label="Gruppo di lavoro">
              <workgroup-input-field
                :value="r.workgroup"
                disabled
                plaintext
              />
            </info-field>
          </div>
          <div class="mt-2 border-top border-secondary pt-2">
            {{ r.description || '&lt;Nessuna descrizione&gt;' }}
          </div>
        </router-link-card>
      </b-col>
    </b-row>
    <div
      v-if="page.permissions && page.permissions.create"
      slot="bottom-buttons"
      class="text-right mb-2">
      <b-button variant="success" :to="{ name: 'Analysis', params: { id: 'new' } }">
        Nuovo
      </b-button>
    </div>
  </find-page-layout>
</template>
<script>
import AnalysisService from 'app/services/AnalysisService';
import FindPageMixin from 'vue-core/mixins/FindPageMixin';

export default {
  mixins: [ FindPageMixin ],

  created() {
    this.service = AnalysisService;
  },

  computed: {
    breadcrumbs() {
      return [
        {
          label: 'Home',
          link: '/protected'
        },
        {
          label: 'Analisi'
        }
      ];
    },

    sorters() {
      return [
        {
          label: 'Id',
          path: 'id'
        },
      ];
    }
  }
}
</script>
